/* src/modules/dashboard/action_types.js */

export const fetchDashboardLessonsTypes = [
  'FETCH_DASHBOARD_LESSONS',
  'FETCH_DASHBOARD_LESSONS_SUCCESS',
  'FETCH_DASHBOARD_LESSONS_FAIL',
];

export const fetchDashboardUsersTypes = [
  'FETCH_DASHBOARD_USERS',
  'FETCH_DASHBOARD_USERS_SUCCESS',
  'FETCH_DASHBOARD_USERS_FAIL',
];

export const fetchDashboardStudentsTypes = [
  'FETCH_DASHBOARD_STUDENTS',
  'FETCH_DASHBOARD_STUDENTS_SUCCESS',
  'FETCH_DASHBOARD_STUDENTS_FAIL',
];

export const fetchDashboardTutorsTypes = [
  'FETCH_DASHBOARD_TUTORS',
  'FETCH_DASHBOARD_TUTORS_SUCCESS',
  'FETCH_DASHBOARD_TUTORS_FAIL',
];

export const fetchPopularCoursesTypes = [
  'FETCH_POPULAR_COURSES',
  'FETCH_POPULAR_COURSES_SUCCESS',
  'FETCH_POPULAR_COURSES_FAIL',
];

export const CHANGE_NUMBER_OF_LESSONS_TIME_FRAME = 'CHANGE_NUMBER_OF_LESSONS_TIME_FRAME';
export const CHANGE_NUMBER_OF_LESSONS_TYPE = 'CHANGE_NUMBER_OF_LESSONS_TYPE';
export const CHANGE_NUMBER_OF_LESSONS_START_DATE = 'CHANGE_NUMBER_OF_LESSONS_START_DATE';
export const CHANGE_NUMBER_OF_LESSONS_END_DATE = 'CHANGE_NUMBER_OF_LESSONS_END_DATE';

export const CHANGE_NUMBER_OF_USERS_TIME_FRAME = 'CHANGE_NUMBER_OF_USERS_TIME_FRAME';
export const CHANGE_NUMBER_OF_USERS_TYPE = 'CHANGE_NUMBER_OF_USERS_TYPE';
export const CHANGE_NUMBER_OF_USERS_START_DATE = 'CHANGE_NUMBER_OF_USERS_START_DATE';
export const CHANGE_NUMBER_OF_USERS_END_DATE = 'CHANGE_NUMBER_OF_USERS_END_DATE';

export const CHANGE_REVENUE_TIME_FRAME = 'CHANGE_REVENUE_TIME_FRAME';
export const CHANGE_REVENUE_TYPE = 'CHANGE_REVENUE_TYPE';
export const CHANGE_REVENUE_START_DATE = 'CHANGE_REVENUE_START_DATE';
export const CHANGE_REVENUE_END_DATE = 'CHANGE_REVENUE_END_DATE';

export const CHANGE_PROFIT_TIME_FRAME = 'CHANGE_PROFIT_TIME_FRAME';
export const CHANGE_PROFIT_TYPE = 'CHANGE_PROFIT_TYPE';
export const CHANGE_PROFIT_START_DATE = 'CHANGE_PROFIT_START_DATE';
export const CHANGE_PROFIT_END_DATE = 'CHANGE_PROFIT_END_DATE';



// WEBPACK FOOTER //
// ./src/modules/dashboard/action_types.js